import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import Styleguide from "@store/Framework/Types/Styleguide";
import { focusStyles } from "@store/Themes/common/mixins/common";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { css } from "styled-components";

const overflowMenu: Styleguide["overflowMenu"] = {
    defaultProps: {
        buttonProps: {
            ...buttonResetProps,
            css: css`
                ${buttonResetProps.css}
                transition: ${transitionHoverStyles("color")};

                &:hover,
                &[aria-expanded="true"] {
                    color: ${getColor("primary")};
                }
            `,
        },
        iconProps: {
            css: css`
                vertical-align: top;
                top: 0 !important;
            `,
        },
        cssOverrides: {
            wrapper: css`
                width: auto;
                height: auto;
            `,
            menu: css`
                overflow-y: auto;
                box-shadow: ${x => x.theme.shadows.e80};
            `,
            menuItem: css`
                ${focusStyles(true)}
                display: flex;
                padding: ${pxToRem(10, 16, 11)};
                margin-top: -${pxToRem(1)};
                font-size: ${x => x.theme.design.typography.size.small};
                border-top: 1px solid ${getColor("common.border")};
                transition: ${transitionHoverStyles("color", "background-color")};
                font-weight: normal;
                color: inherit;
                text-decoration: none;

                &:hover,
                &:active,
                &:focus {
                    background-color: transparent;
                    text-decoration: none;
                    color: inherit;
                }

                &:hover,
                &:active {
                    color: ${getColor("primary")};
                }
            `,
        },
    },
};

export default overflowMenu;
